/**
 * Telegram Mini App wrapper for the Aptitude drill history page.
 * URL: /tg/aptitude-drill/history
 *
 * Reuses AptitudeHistory — TelegramShell handles initData → JWT handshake,
 * after which the regular component runs with auth set up in context.
 */

import React from 'react';
import TelegramShell from '../components/TelegramShell';
import AptitudeHistory from './AptitudeHistory';

const TelegramAptitudeHistory: React.FC = () => (
  <TelegramShell>
    <AptitudeHistory />
  </TelegramShell>
);

export default TelegramAptitudeHistory;
